import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import AppSwitchLink from "src/components/Nav/AppSwitchLink";
import { trackEvent } from "src/services/segment";
import { EVENT_TRACKING } from "src/consts/eventTracking";

const LinkWrapper = styled.li`
  padding: 0 0 10px 0;
  &:last-child {
    padding-bottom: 0;
  }
`;

const LinksListItem = ({ link }) => {
  const { label, value } = link;

  return (
    <LinkWrapper>
      <AppSwitchLink
        label={label || value}
        href={value}
        showFavicon={true}
        onClick={() => {
          trackEvent(EVENT_TRACKING.URL_CLICKED, {
            action: "team_links_link_clicked",
          });
        }}
      />
    </LinkWrapper>
  );
};

LinksListItem.propTypes = {
  link: PropTypes.object,
};

export default LinksListItem;
